module.exports = __webpack_public_path__ + "static/media/Icon-Expand.1c6f91b0.svg";